export default "__VITE_ASSET__pas8_jtj__"